import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const init = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: baseUrl + "/projects/" + projectId + "/init",
    needToken: true
  });
};

export const helpStatus = status => {
  return Request({
    method: "patch",
    url: baseUrl + "/changeHelpStatus",
    needToken: true,
    data:{
      help_status:status,
    }
  });
};
